import { getLastArticleContainer } from '../article-page/helper'
import { createModalGallery } from './index'

export default function (tns) {
  const lastArticleContainer = getLastArticleContainer()

  if (!lastArticleContainer) {
    return
  }

  const galleries = Array.from(
    lastArticleContainer.querySelectorAll(
      '.ArticleContent .tns-outer:not(.wp-block-product-infusion-block-product-infusion-multiple .tns-outer)'
    )
  )

  galleries.forEach((gallery) => {
    const images = Array.from(gallery.querySelectorAll('.tns-item img'))

    if (images.length > 0) {
      createModalGallery(images, tns)
    }
  })
}
